import { router } from 'expo-router';
import { useCallback } from 'react';

import type { ShopDetailResponse } from '@/api/shop/shopDetailQuery/types';
import { routes } from '@/constants/routes';
import { isCommissionShop } from '@/utils/shop/isCommissionShop';

interface UseGiftCardEntryParams {
  shop: ShopDetailResponse;
  shopRoute: string;
  promoId?: string;
  isAnyProfessional: boolean;
  selectedServicesCount: number;
  barberId: string;
}

interface UseGiftCardEntryResult {
  showGiftCard: boolean;
  handleGiftCardPress: () => void;
}

export function useGiftCardEntry({
  shop,
  shopRoute,
  promoId,
  isAnyProfessional,
  selectedServicesCount,
  barberId,
}: UseGiftCardEntryParams): UseGiftCardEntryResult {
  const showGiftCard =
    selectedServicesCount === 0 &&
    (isAnyProfessional
      ? shop.giftCardEnabled &&
        shop.customerGiftCardEnabled &&
        isCommissionShop(shop.kind)
      : shop.customerGiftCardEnabled && shop.barberSpecificGC);

  const handleGiftCardPress = useCallback(() => {
    router.push(
      routes.giftCard({
        promoId,
        shopId: shopRoute,
        barberId: isAnyProfessional ? undefined : barberId,
      }),
    );
  }, [isAnyProfessional, barberId, promoId, shopRoute]);

  return { showGiftCard, handleGiftCardPress };
}
